import React, { Component } from "react";
import global from "../../global.css";
import classes from "./ContactUsPage.css";
import SignFirtOne from "../../assets/Mail.png";

class ContactUsPage extends Component {
  state = {
    RightNowPart: 1
  };

  render() {
    return (
      <div className={classes.BackColor}>
        <div className={classes.Background}>
          <div className={global.Responsive} onWheel={this.onMouseWheel}>
            <div className={classes.partOne}>
              <img
                src={SignFirtOne}
                alt="تصویر SIGN"
                className={classes.SignFirtOne}
              />
              <div>
                <h2>تماس با ما </h2>
                <p>
                  تیم پشتیبانی محراب سیر کیش به صورت 24 ساعته و در 7 روز هفته
                  آماده پاسخگویی به سوالات شما عزیزان است
                </p>
                <p>
                  در صورتی که هرگونه سوال یا مشکل در فرایند خرید بلیت، رزرو هتل،
                  خدمات بیمه و مسافرتی دارید، از طریق شماره های تماس، فکس و
                  ایمیل یا با پرکردن فرم زیر با ما در ارتباط باشید.
                </p>
                <p>
                  همچنین منتظر شنیدن، هرگونه پیشنهاد و یا انتقاد از شما دوستان
                  هستیم
                </p>
                <h3>راه های ارتباطی</h3>
                <p>
                  دفتر تهران :<span dir="ltr"> 021 41578</span>
                </p>
                <p>
                  تلفن تماس :<span dir="ltr"> 076 44421969</span>
                </p>
                <table className={classes.partTable}>
                  <caption>
                    <h3>41578 021</h3>
                  </caption>
                  <tbody>
                    <tr>
                      <td>واحد</td>
                      <td>داخلی</td>
                    </tr>
                    <tr>
                      <td>چارتر داخلی</td>
                      <td>123</td>
                    </tr>
                    <tr>
                      <td>چارتر خارجی</td>
                      <td>176</td>
                    </tr>
                    <tr>
                      <td>پرواز سیستمی</td>
                      <td>153</td>
                    </tr>
                    <tr>
                      <td>عتبات</td>
                      <td>111</td>
                    </tr>
                    <tr>
                      <td>چارتر مشهد</td>
                      <td>115</td>
                    </tr>
                    <tr>
                      <td>قطار</td>
                      <td>191</td>
                    </tr>
                    <tr>
                      <td>شکایات</td>
                      <td>122</td>
                    </tr>
                    <tr>
                      <td>تور و هنل داخلی</td>
                      <td>182</td>
                    </tr>
                    <tr>
                      <td>تور و هنل خارجی</td>
                      <td>186</td>
                    </tr>
                    <tr>
                      <td>حسایداری Sign</td>
                      <td>206</td>
                    </tr>
                    <tr>
                      <td>اوپراتور</td>
                      <td>101</td>
                    </tr>
                    <tr>
                      <td>حسابداری استرداد</td>
                      <td>123</td>
                    </tr>
                    <tr>
                      <td>بازرگانی</td>
                      <td>123</td>
                    </tr>
                    <tr>
                      <td>مدیریت</td>
                      <td>323</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div className={classes.MapPart}>
          <iframe
            title="this is google site map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1619.3103073371904!2d51.43198442219273!3d35.735547907416695!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3f8e03fd1a384e1b%3A0x9a1ea51be28e0468!2sMehrab+Gasht+Sabz+Travel+Agency!5e0!3m2!1sen!2s!4v1545213940513"
            // width="1600"
            height="400"
            frameBorder="0"
            style={{ border: 0 }}
            allowFullScreen
          />
        </div>
      </div>
    );
  }
}

export default ContactUsPage;
